import { useCallback, useEffect, useState } from 'react';

import { RemoteConfig } from '@services/firebase/remote-config/types';
import { fetchRemoteConfig } from '@services/firebase/remote-config/remote-config';

const useRemoteConfig = () => {
    const [remoteConfig, setRemoteConfig] = useState<RemoteConfig | null>(null);

    const fetchConfig = useCallback(async () => {
        const config = await fetchRemoteConfig();
        setRemoteConfig(config);
    }, []);

    useEffect(() => {
        if (remoteConfig === null) {
            void fetchConfig();
        }
    }, [fetchConfig, remoteConfig]);

    const getRemoteValue = useCallback(
        (keyPath: string) => {
            const parts = keyPath.split('.');
            let current: any = remoteConfig;

            for (const part of parts) {
                if (current && typeof current === 'object' && part in current) {
                    current = current[part];
                } else {
                    return null;
                }
            }

            return current;
        },
        [remoteConfig]
    );

    return { remoteConfig, fetchConfig, getRemoteValue };
};

export { useRemoteConfig };
